import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Section, SectionHeading, Reveal } from '../components/ui';
import { FONT, TYPE } from '../theme/tokens';

// ---------------------------------------------------------------------------
// Adresa greșită.
//
// Înainte nu exista nicio rută de rezervă: orice adresă în afara celor șase
// randa un `<main>` gol, deci vizitatorul rămânea cu meniul sus, footer-ul jos
// și nimic între ele — arăta ca un site stricat, nu ca un link greșit.
//
// Aici primește ce-i trebuie: ce s-a întâmplat și încotro s-o ia.
// ---------------------------------------------------------------------------
export default function NotFound() {
  const { t } = useTranslation();

  return (
    <Section first component="section">
      <Box sx={{ textAlign: 'center', maxWidth: 620, mx: 'auto', py: { xs: 2, md: 6 } }}>
        <Reveal>
          <Typography
            component="p"
            aria-hidden
            sx={{
              fontFamily: FONT.mono,
              fontSize: 'clamp(3.5rem, 12vw, 6rem)',
              fontWeight: 600,
              letterSpacing: '-0.04em',
              lineHeight: 1,
              color: 'var(--qf-line-2)',
              m: 0,
              mb: 3,
            }}
          >
            404
          </Typography>
        </Reveal>

        <SectionHeading
          component="h1"
          align="center"
          eyebrow={t('notFound.eyebrow')}
          title={t('notFound.title')}
          lede={t('notFound.description')}
          titleSx={TYPE.h1}
          maxWidth={560}
        />

        <Reveal
          delay={0.1}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            gap: 1.5,
            mt: { xs: 4.5, md: 5.5 },
          }}
        >
          <Button component={Link} to="/" variant="contained" size="large">
            {t('notFound.home')}
          </Button>
          <Button component={Link} to="/contact" variant="outlined" size="large">
            {t('home.ctaAction')}
          </Button>
        </Reveal>
      </Box>
    </Section>
  );
}
